import React from 'react';
import { ZoomIn, ZoomOut, Maximize, Plus, LayoutGrid } from 'lucide-react';

interface StreamGraphControlsProps {
  /** Current zoom scale (0.1 to 2) */
  scale: number;
  /** Zoom in handler */
  onZoomIn: () => void;
  /** Zoom out handler */
  onZoomOut: () => void;
  /** Fit to window handler */
  onFitToWindow: () => void;
  /** Create new node handler */
  onCreateNode: () => void;
  /** Auto layout handler */
  onAutoLayout: () => void;
}

/**
 * Toolbar component for graph controls.
 * Provides zoom, fit-to-window, create node, and auto-layout actions.
 */
export function StreamGraphControls({
  scale,
  onZoomIn,
  onZoomOut,
  onFitToWindow,
  onCreateNode,
  onAutoLayout,
}: StreamGraphControlsProps) {
  return (
    <div className="absolute bottom-6 right-6 flex flex-col gap-2 bg-surface-900/90 backdrop-blur border border-surface-600 p-2 rounded-lg shadow-xl z-20">
      <button
        onClick={onCreateNode}
        className="p-2 hover:bg-surface-800 rounded text-text-secondary hover:text-primary-400 transition-colors"
        title="Add Task"
      >
        <Plus className="w-5 h-5" />
      </button>
      <div className="h-px bg-surface-600" />
      <button
        onClick={onZoomIn}
        disabled={scale >= 2}
        className="p-2 hover:bg-surface-800 rounded text-text-secondary hover:text-text-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title="Zoom in (Cmd +)"
      >
        <ZoomIn className="w-5 h-5" />
      </button>
      <div className="text-center text-xs text-text-muted py-1">
        {Math.round(scale * 100)}%
      </div>
      <button
        onClick={onZoomOut}
        disabled={scale <= 0.1}
        className="p-2 hover:bg-surface-800 rounded text-text-secondary hover:text-text-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title="Zoom out (Cmd -)"
      >
        <ZoomOut className="w-5 h-5" />
      </button>
      <button
        onClick={onFitToWindow}
        className="p-2 hover:bg-surface-800 rounded text-text-secondary hover:text-text-primary transition-colors"
        title="Fit to window (Cmd 0)"
      >
        <Maximize className="w-5 h-5" />
      </button>
      <div className="h-px bg-surface-600" />
      <button
        onClick={onAutoLayout}
        className="p-2 hover:bg-surface-800 rounded text-text-secondary hover:text-primary-400 transition-colors"
        title="Auto Layout"
      >
        <LayoutGrid className="w-5 h-5" />
      </button>
    </div>
  );
}
